export enum UnicodeEntity {
    NoBreakSpace = '\u00a0',
    MinusSign = '\u2212',
    Colon = '\u003a',
}

export const SpacedMinusSign = `${UnicodeEntity.NoBreakSpace}${UnicodeEntity.MinusSign}${UnicodeEntity.NoBreakSpace}`;